import { v4 as uuidv4 } from "uuid";
import { CommonNS } from "../../../../../../Common/CommonNS.js";
export const initDOM = (self) => {
  const canvas_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "svg"
  );
  self._canvas_el = canvas_el;
  canvas_el.style.backgroundColor = "#F8F9FA";
  canvas_el.setAttributeNS(null, "x", "0");
  canvas_el.setAttributeNS(null, "y", "0");
  canvas_el.setAttributeNS(null, "width", "0");
  canvas_el.setAttributeNS(null, "height", "0");
  canvas_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] = "canvas";
  const layers_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "svg"
  );
  self._layers_el = layers_el;
  layers_el.setAttributeNS(null, "x", "0");
  layers_el.setAttributeNS(null, "y", "0");
  layers_el.setAttributeNS(null, "width", "0");
  layers_el.setAttributeNS(null, "height", "0");
  layers_el.setAttributeNS(null, "preserveAspectRatio", "xMidYMid meet");
  layers_el.setAttributeNS(null, "viewBox", "0 0 0 0");
  layers_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] = "layers";
  canvas_el.appendChild(layers_el);
  const art_board_layer_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  self._art_board_layer_el = art_board_layer_el;
  art_board_layer_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "art-board-layer";
  layers_el.appendChild(art_board_layer_el);
  const background_layer_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  self._background_layer_el = background_layer_el;
  background_layer_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "background-layer";
  layers_el.appendChild(background_layer_el);
  const target_image_layer_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  self._target_image_layer_el = target_image_layer_el;
  target_image_layer_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "target-image-layer";
  layers_el.appendChild(target_image_layer_el);
  const foreground_layer_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  self._foreground_layer_el = foreground_layer_el;
  foreground_layer_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "foreground-layer";
  layers_el.appendChild(foreground_layer_el);
  const clip_path_layer_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  self._clip_path_layer_el = clip_path_layer_el;
  clip_path_layer_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "clip-path-layer";
  layers_el.appendChild(clip_path_layer_el);
  const empty_grid_layer_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  self._empty_grid_layer_el = empty_grid_layer_el;
  empty_grid_layer_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "empty-grid-layer";
  layers_el.appendChild(empty_grid_layer_el);
  const existing_grid_layer_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  self._existing_grid_layer_el = existing_grid_layer_el;
  existing_grid_layer_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "existing-grid-layer";
  layers_el.appendChild(existing_grid_layer_el);
  const selector_grid_layer_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  self._selector_grid_layer_el = selector_grid_layer_el;
  selector_grid_layer_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "selector-grid-layer";
  layers_el.appendChild(selector_grid_layer_el);
  const copy_source_grid_layer_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  self._copy_source_grid_layer_el = copy_source_grid_layer_el;
  copy_source_grid_layer_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "copy-source-grid-layer";
  layers_el.appendChild(copy_source_grid_layer_el);
  const copy_destination_unselected_empty_grid_layer_el =
    self._document.createElementNS(CommonNS.ConstNS.SVG_NAMESPACE, "g");
  self._copy_destination_unselected_empty_grid_layer_el =
    copy_destination_unselected_empty_grid_layer_el;
  copy_destination_unselected_empty_grid_layer_el.dataset[
    CommonNS.ConstNS.DATA_KEY_ROLE
  ] = "copy-destination-unselected-empty-grid-layer";
  layers_el.appendChild(copy_destination_unselected_empty_grid_layer_el);
  const copy_destination_unselected_existing_grid_layer_el =
    self._document.createElementNS(CommonNS.ConstNS.SVG_NAMESPACE, "g");
  self._copy_destination_unselected_existing_grid_layer_el =
    copy_destination_unselected_existing_grid_layer_el;
  copy_destination_unselected_existing_grid_layer_el.dataset[
    CommonNS.ConstNS.DATA_KEY_ROLE
  ] = "copy-destination-unselected-existing-grid-layer";
  layers_el.appendChild(copy_destination_unselected_existing_grid_layer_el);
  const copy_destination_selected_grid_layer_el =
    self._document.createElementNS(CommonNS.ConstNS.SVG_NAMESPACE, "g");
  self._copy_destination_selected_grid_layer_el =
    copy_destination_selected_grid_layer_el;
  copy_destination_selected_grid_layer_el.dataset[
    CommonNS.ConstNS.DATA_KEY_ROLE
  ] = "copy-destination-selected-grid-layer";
  layers_el.appendChild(copy_destination_selected_grid_layer_el);
  const art_board_filter_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "filter"
  );
  art_board_filter_el.setAttributeNS(
    null,
    "id",
    `${CommonNS.ConstNS.DATA_KEY_ROLE}__art-board-filter__${uuidv4()}`
  );
  art_board_filter_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "art-board-filter";
  const art_board_filter_drop_shadow_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "feDropShadow"
  );
  self._art_board_filter_drop_shadow_el = art_board_filter_drop_shadow_el;
  art_board_filter_drop_shadow_el.setAttributeNS(null, "dx", "0");
  art_board_filter_drop_shadow_el.setAttributeNS(null, "dy", "0");
  art_board_filter_drop_shadow_el.setAttributeNS(null, "stdDeviation", "0");
  art_board_filter_drop_shadow_el.setAttributeNS(
    null,
    "flood-color",
    "#000000"
  );
  art_board_filter_drop_shadow_el.setAttributeNS(null, "flood-opacity", "0.05");
  art_board_filter_el.appendChild(art_board_filter_drop_shadow_el);
  const art_board_rect_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "rect"
  );
  self._art_board_rect_el = art_board_rect_el;
  art_board_layer_el.appendChild(art_board_filter_el);
  art_board_rect_el.setAttributeNS(null, "x", "0");
  art_board_rect_el.setAttributeNS(null, "y", "0");
  art_board_rect_el.setAttributeNS(null, "width", "0");
  art_board_rect_el.setAttributeNS(null, "height", "0");
  art_board_rect_el.setAttributeNS(null, "fill", "#FFFFFF");
  art_board_rect_el.setAttributeNS(
    null,
    "filter",
    `url(#${art_board_filter_el.id})`
  );
  art_board_rect_el.setAttributeNS(null, "stroke", "#E9ECEF");
  art_board_rect_el.setAttributeNS(null, "stroke-width", "0");
  art_board_rect_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] = "art-board";
  art_board_layer_el.appendChild(art_board_rect_el);
  const background_base_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "rect"
  );
  background_base_el.setAttributeNS(null, "x", "0");
  background_base_el.setAttributeNS(null, "y", "0");
  background_base_el.setAttributeNS(null, "width", "0");
  background_base_el.setAttributeNS(null, "height", "0");
  background_base_el.setAttributeNS(null, "fill", "none");
  background_base_el.setAttributeNS(null, "stroke", "none");
  background_base_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "background-base";
  background_layer_el.appendChild(background_base_el);
  self._background_base_el = background_base_el;
  const background_color_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "rect"
  );
  background_color_el.setAttributeNS(null, "x", "0");
  background_color_el.setAttributeNS(null, "y", "0");
  background_color_el.setAttributeNS(null, "width", "0");
  background_color_el.setAttributeNS(null, "height", "0");
  background_color_el.setAttributeNS(null, "fill", "none");
  background_color_el.setAttributeNS(null, "stroke", "none");
  background_color_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "background-color";
  background_layer_el.appendChild(background_color_el);
  self._background_color_el = background_color_el;
  const background_image_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "image"
  );
  background_image_el.setAttributeNS(null, "x", "0");
  background_image_el.setAttributeNS(null, "y", "0");
  background_image_el.setAttributeNS(null, "width", "0");
  background_image_el.setAttributeNS(null, "height", "0");
  background_image_el.setAttributeNS(null, "stroke", "none");
  background_image_el.setAttributeNS(
    null,
    "preserveAspectRatio",
    "xMidYMid slice"
  );
  background_image_el.style.display = "none";
  background_image_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "background-image";
  background_layer_el.appendChild(background_image_el);
  self._background_image_el = background_image_el;
  const clip_path_defs_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "defs"
  );
  clip_path_layer_el.appendChild(clip_path_defs_el);
  const clip_path_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "clipPath"
  );
  self._clip_path_el = clip_path_el;
  clip_path_el.setAttributeNS(
    null,
    "id",
    `${CommonNS.ConstNS.DATA_KEY_ROLE}__clip-path__${uuidv4()}`
  );
  clip_path_defs_el.appendChild(clip_path_el);
  target_image_layer_el.setAttributeNS(
    null,
    "clip-path",
    `url(#${clip_path_el.id})`
  );
};
